<template>
    <el-input
      :value="computedInputValue"
      @input="onInput($event)"
      :required="!!required"
      :disabled="!!disabled"
      :placeholder="placeholder"
      autocomplete="off">
    </el-input>
</template>

<script>
export default {
  name: 'ElQtyInput',
  props: {
    value: Number,
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    placeholder: String
  },
  data() {
    return {
      inputValue: '0',
    };
  },
  mounted() {
    if (this.value !== undefined) this.inputValue = this.value;
  },
  methods: {
    onInput(val) {
      if (/^[0-9]*$/.test(val)) {
        const value = /^[0]+$/.test(val) ? 0 : val;
        this.inputValue = `${parseInt(value, 10) || 0}`;
        this.$emit('input', parseInt(this.inputValue, 10));
      }
    }
  },
  computed: {
    computedInputValue: {
      get() {
        return this.inputValue;
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal === undefined) this.inputValue = '';
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
